// Round 5 item 9: genre/energy/language/theme are now arrays (each comma value
// is its own filter). These helpers render/normalize them and stay backward
// compatible with any legacy scalar-string value.
export const asArray = (v) => (Array.isArray(v) ? v : v ? [v] : []);
export const fmtList = (v, sep = ", ") => asArray(v).filter(Boolean).join(sep);
